import { LookupModel } from 'app/models/shared/lookup.model';
import { ContactResultModel } from './contact.model';
import { OpportunityActivityResultModel } from './opportunityActivityResult.model';
import { CustomFieldResultModel } from '../shared/customField.model';
export class OpportunityModel
{
	id: string;
	opportNo: number;
	openDate: Date;
	description: string;
	dealershipId: string;
	originEnum: number;
	referralMethodId: string;
	campaignId: string;
	nextActDate: string;
	nextActId: string;
	customerId: string;
	statusEnum: number;
	closedDate: Date;
	reasonOpenId: string;
	reasonWonId: string;
	reasonLostId: string;
	estValue: number;
	comment: string;
	probabilityEnum: number;
	salesPersonId: string;
	createdDate: Date;
	modifiedDate: Date;
	name: string;
	caption: string;
	reference: string;
	lastActivityId: string;
	dealership: ContactResultModel;
	salesPerson: ContactResultModel;
	nextAct: LookupModel;
	customer: ContactResultModel;
	origin: LookupModel;
	referralMethod: LookupModel;
	campaign: LookupModel;
	probability: LookupModel;
	status: LookupModel;
	reasonOpen: LookupModel;
	reasonWon: LookupModel;
	reasonLost: LookupModel;
	lastActivity: OpportunityActivityResultModel;
	activities: OpportunityActivityResultModel[];

	customField1: string;
	customField2: string;
	customField3: string;
	customField4: string;
	customField5: string;
	customField6: string;
	
	customField1_Object: CustomFieldResultModel;
	customField2_Object: CustomFieldResultModel;
	customField3_Object: CustomFieldResultModel;
	customField4_Object: CustomFieldResultModel;
	customField5_Object: CustomFieldResultModel;
	customField6_Object: CustomFieldResultModel;

	// Transient
	vehicleThumbnailUrl: string = "";
	lastVehicleOdoReading: number = 0;
	companyCode: string = "";
}
